module.exports = __webpack_public_path__ + "img/gd-sharepoint-agenda.cb1e329c.png";